import PasskeyCreationFailed from '$modals/passkey-creation-failed/PasskeyCreationFailed.svelte';
import { openModal } from '$components/bottom-sheet/index.svelte';
import type { Address } from '$types/address';
import { getCometh4337Wallet } from '$services/cometh/getComethWallet';

//This flow should create a new 4337 wallet with safe version 1.4.0
export const createWallet = async (): Promise<Address | undefined> => {
  try {
    const { walletAddress } = await getCometh4337Wallet();

    return walletAddress as Address;
  } catch (_) {
    openModal(PasskeyCreationFailed);
  }
};
